import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomDetectAiMappingRunAreaMutation } from "generated/graphql";

export const useDetectAiMappingRunArea = () => {
  const [mutation, { data, loading, error }] = useCustomDetectAiMappingRunAreaMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "detectAiMappingRunArea" },
    { hideMessage: true }
  );
};
